import { useRouter } from 'vue-router';

export function usePrevRoute() {
  const router = useRouter();
  if (window.history.state.back) {
    return router.resolve({ path: window.history.state.back });
  }
  return {};
}
